import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ready-ui-symbol',
  templateUrl: './symbol.component.html',
  styleUrls: ['./symbol.component.scss']
})
export class SymbolComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
